import Helpers from '@/shared/helpers/functions';

const POLICY_EXPIRATION_IN_DAYS = 0;

class Policy {
  constructor (data = {}) {
    this.policyNumber = data.policyNumber;
    this.dateStarted = data.dateStarted;
    this.dateEnded = data.dateEnded;
    this.product = new PolicyProduct(data.product);

    this.productType = this.product && this.product.productType && this.product.productType.code;
    this.categoryType = this.product && this.product.category && this.product.category.description;

    this.isActive = this._getIsActive(); // data.isActive;
  }

  _getIsActive () {
    if (this.dateEnded == null || this.dateEnded === '') return true;
    if (Helpers.Dates.differenceFromNowInDays(this.dateEnded) > POLICY_EXPIRATION_IN_DAYS) return false;
    return true;
  }

  isActiveOnDate (date) {
    let _date = null;
    if (date == null) {
      _date = new Date();
    } else _date = new Date(date);

    if (this.dateStarted == null || this.dateStarted === '') return false;
    if (_date >= new Date(this.dateStarted)) {
      if (this.dateEnded == null || this.dateEnded === '') return true;

      // untilDate should be expiryDate as discussed
      if (_date <= new Date(Helpers.Dates.addDays(this.dateEnded, POLICY_EXPIRATION_IN_DAYS))) return true;
      else return false;
    }

    return true;
  }
}

class PolicyProduct {
  constructor (data = {}) {
    this.id = data.id;
    this.description = data.description;
    this.descriptionDarti = data.descriptionDarti;
    this.sequenceNumber = data.sequenceNumber;
    this.productType = new PolicyProductType(data.kindOfInsurance);
    this.category = new PolicyProductCategory(data.productCategory);
  }
}

class PolicyProductType {
  constructor (data = {}) {
    this.code = data.code;
    this.description = data.description;
  }
}

class PolicyProductCategory {
  constructor (data = {}) {
    this.id = data.id;
    this.description = data.description && data.description.toUpperCase();
  }
}

export { Policy as default };
